import $ from 'jquery';
import slick from 'slick-carousel';

$('.rooms-carousel').slick({
    dots: false,
    infinite: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    draggable: true,
    responsive: true,
});

$('.cards-carousel').on('init', function (event, slick, direction) {

    // check to see if there are four or less slides
    if (!($('.cards-carousel .slick-slide').length > 4) && (screen.width > 991)) {
        // remove arrows
        $('.cards-carousel__arrowsContainer').hide();

    }
});

$('.cards-carousel').each(function ()  {

    var slider = $(this);

    slider.slick({
        dots: false,
        infinite: true,
        //appendArrows: ".cards-carousel__arrowsContainer",
        arrows: true,
        draggable: true,
        autoplay: false,
        centerMode: true,
        centerPadding: '170px',
        slidesToShow: 2,
        slidesToScroll: 1,
        swipeToSlide: true,
        mobileFirst: true,
        prevArrow: slider.closest('.js-carousel-wrapper').find('.slick-prev'),
        nextArrow: slider.closest('.js-carousel-wrapper').find('.slick-next'),

        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '150px',
                    mobileFirst: true,
                    arrows: true,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 811,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '170px',
                    mobileFirst: true,
                    arrows: true,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 425,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '170px',
                    mobileFirst: true,
                    arrows: true,
                    initialSlide: 1
                }
            },
            {
                breakpoint: 376,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                    centerPadding: '130px',
                    arrows: true,
                }
            },
            {
                breakpoint: 1,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                    centerPadding: '90px',
                    arrows: true,
                }
            }
        ]

    });
})



$('.promo-cards-carousel').slick({
    dots: false,
    infinite: true,
    arrows: false,
    draggable: true,
    autoplay: false,
    centerPadding: '150px',
    swipeToSlide: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    unslick: true,

    responsive: [
        {
            breakpoint: 9999,
            settings: "unslick"
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '80px',
                initialSlide: 1,
            }
        },
        {
            breakpoint: 425,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                arrows: false,
                centerPadding: '90px',
            }
        }
    ]

});
